export default () => {
  const runtimeConfig = useRuntimeConfig()
  return runtimeConfig.public.buildTime
}
